export default "__VITE_ASSET__CVLgRpLz__"